import { notification } from 'antd';
import { useState } from 'react';

import useAutoCredRequestId from '@/components/App/NewOrder/hooks/useAutoCredRequestId';
import { DictTypes } from '@/constants';
import { autoCreditApi } from '@/integrations/app.api/auto-credit.api';
import { handleError } from '@/services/handleError';
import { useAppSelector } from '@/store';

import type { RecreateBanksListInterface } from '../types/recreate-banks';

interface IProps {
  handleClose: () => void;
}

const useRecreate = ({ handleClose }: IProps) => {
  const { dicts } = useAppSelector((state) => state.dict);

  const { requestId } = useAutoCredRequestId();

  const [recreateLoading, setRecreateLoading] = useState(false);

  const handleSubmit = async (
    banks: RecreateBanksListInterface[],
    isUsedAuto: boolean
  ) => {
    if (!dicts?.[DictTypes.Banks]?.content) return;
    setRecreateLoading(true);

    const banksFromDict = dicts?.[DictTypes.Banks]?.content;
    const preparedBanks = banksFromDict.reduce(
      (acc, bank) => {
        acc[bank.name] = { timeout: '0', is_active: false };
        return acc;
      },
      {} as Record<string, { timeout: string; is_active: boolean }>
    );
    banks.forEach((bank) => {
      // 'code' - это name банка из словаря (см. ./useBanksList.ts)
      preparedBanks[bank.code] = { timeout: '0', is_active: bank.checked };
    });

    try {
      await autoCreditApi.reCreateRequest(requestId, preparedBanks, isUsedAuto);
      notification.success({
        title: 'Заявка успешно переотправлена'
      });
      handleClose();
    } catch (error) {
      handleError(error, {
        customTitle: 'Произошла ошибка. Пожалуйста, попробуйте позже'
      });
    }

    setRecreateLoading(false);
  };

  return { recreateLoading, handleSubmit };
};

export default useRecreate;
